import React, { ReactNode } from 'react';
import { theme } from '@breakroom-nx/assets';
import { Box, Center } from 'native-base';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

export interface RingProps {
  children: ReactNode;
  hidden?: boolean;
  size?: string;
  color?: string;
}

export const Ring = ({
  children,
  hidden = false,
  size = '70px',
  color = theme.colors.primary[400],
}: RingProps) => {
  return (
    <Box size={size} alignItems={'center'} alignContent={'center'}>
      <Center height={'full'} width={'full'}>
        <Box
          position={'absolute'}
          rounded={'full'}
          alignSelf={'center'}
          alignItems={'center'}
          justifyContent={'center'}
          size={hidden ? '100%' : '70%'}
        >
          {children}
        </Box>
        <CircularProgressbar
          value={hidden ? 0 : 100}
          strokeWidth={6}
          styles={buildStyles({
            rotation: 0,
            strokeLinecap: 'round',
            pathTransitionDuration: 0.5,
            pathColor: color,
            trailColor: 'transparent',
          })}
        />
      </Center>
    </Box>
  );
};
